/** Status and method choices shared by the record-payment dialog and the edit drawer. */

export const PAYMENT_STATUSES = [
  { value: "pending", label: "Pending" },
  { value: "paid", label: "Paid" },
  { value: "late", label: "Late" },
  { value: "partial", label: "Partial" },
];

export const PAYMENT_METHODS = [
  { value: "cash", label: "Cash" },
  { value: "check", label: "Check" },
  { value: "zelle", label: "Zelle" },
  { value: "venmo", label: "Venmo" },
  { value: "bank_transfer", label: "Bank Transfer" },
  { value: "other", label: "Other" },
];
